import { ReleaseNote } from '../types/release-notes/ReleaseNote';
import { ReleaseNotesProduct } from '../types/release-notes/ReleaseNotesProduct';
import { ReleaseNotesPaginationResponse } from '../types/release-notes/ReleaseNotesResponse';

import { apiCall } from './server/ServerApi';

export async function getProducts(): Promise<
	ReleaseNotesPaginationResponse<ReleaseNotesProduct[]>
> {
	return apiCall(
		'get',
		`${process.env.RELEASE_NOTES_API_URL}/whats-new/products?populate[sub_products][sort]=name:asc&sort=name:asc`,
		{
			isAbsoluteUrl: true
		}
	);
}

export async function getReleaseNotes(
	productId: number,
	page = 1,
	pageSize = 10
): Promise<ReleaseNotesPaginationResponse<ReleaseNote[]>> {
	const params = new URLSearchParams({
		'filters[product][id][$eq]': productId.toString(),
		populate: 'product',
		'pagination[page]': page.toString(),
		'pagination[pageSize]': pageSize.toString(),
		sort: 'published_at:desc'
	});

	return apiCall(
		'get',
		`${process.env.RELEASE_NOTES_API_URL}/whats-new/release-notes?${params.toString()}`,
		{ isAbsoluteUrl: true }
	);
}
